// extracted by mini-css-extract-plugin
export default {"table":"sales-section_table__ObeH4","labelCell":"sales-section_labelCell__lnM-M"};